var _linearGradient, _path, _linearGradient2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "XiPX_WovMdVw_8eHQxiCla",
    x1: 23.999,
    x2: 23.999,
    y1: 23.009,
    y2: 41,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#XiPX_WovMdVw_8eHQxiCla)",
    d: "M43.369,26.439c-0.41-0.8-1.02-1.49-1.76-2c-0.78-0.52-1.648-0.858-2.558-1.068 c-0.98-0.23-1.99-0.34-3-0.34l-5.047,0.004c-0.55,0-1,0.45-1,1l0.002,10.384l-4-10.75c-0.15-0.39-0.52-0.65-0.94-0.65h-4.34 c-0.42,0-0.79,0.26-0.94,0.65l-3.411,9.63c-0.29-0.63-0.7-1.19-1.22-1.64c-0.53-0.49-1.13-0.9-1.77-1.22 c-0.64-0.31-2.01-0.94-2.01-0.94s-0.659-0.274-0.875-0.374c-0.182-0.084-0.5-0.251-0.5-0.626c0-0.25,0.25-0.5,0.625-0.5 c0.625,0,1.614,0.309,1.614,0.309s1.12,0.34,1.65,0.59c0.07,0.03,0.14,0.06,0.21,0.07c0.54,0.13,1.08-0.21,1.2-0.75l0.67-3 c0.09-0.43-0.1-0.86-0.48-1.08c-0.75-0.4-1.54-0.69-2.37-0.88c-0.94-0.22-1.664-0.249-2.624-0.249 c-1.745-0.01-3.174,0.432-4.574,1.462C4.641,25.531,4,27,4,29c0,1.25,0.465,2.27,1.375,3.25c1.09,1.05,1.949,1.343,3.25,2.125 C9.25,34.751,10,35,10,35.499c0,0.375-0.375,0.502-0.625,0.501c-0.625-0.003-1.233-0.127-1.625-0.25 c-0.395-0.124-0.969-0.371-1.529-0.641c-0.06-0.03-0.11-0.05-0.17-0.06c-0.54-0.15-1.09,0.17-1.23,0.7l-0.79,3 c-0.12,0.46,0.1,0.94,0.53,1.15c0.84,0.4,1.73,0.71,2.64,0.9c0.94,0.21,1.452,0.191,2.422,0.201c0.99-0.01,1.966-0.231,2.896-0.571 c0.43-0.15,0.84-0.33,1.23-0.55c0.03,0.1,0.116,0.57,0.176,0.66c0.19,0.27,0.49,0.43,0.82,0.43h4c0.45,0.02,0.86-0.27,1-0.7 l0.644-2.797l0.79,0.25c1.13,0.37,2.35,0.37,3.48,0l0.59-0.2l0.746,2.788c0.14,0.43,0.55,0.71,1,0.69h8c0.55,0,1-0.45,1-1v-4.035 c0.86-0.03,2.133-0.16,2.963-0.38c0.93-0.25,1.82-0.65,2.61-1.2c0.74-0.52,1.35-1.21,1.79-2c0.44-0.85,0.66-1.8,0.64-2.76 C44.019,28.654,43.799,27.309,43.369,26.439z M38.178,31.431c-0.71,0.44-1.553,0.568-2.38,0.55h-0.842v-4.982h0.892 c2.1,0,3.15,1.192,3.15,2.722C39.028,30.391,38.718,31.031,38.178,31.431z M20.875,33.507l2.041-6.478l2.049,6.478 C23.705,34.117,22.424,34.207,20.875,33.507z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "XiPX_WovMdVw_8eHQxiClb",
    x1: 32,
    x2: 32,
    y1: 16,
    y2: 48,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#XiPX_WovMdVw_8eHQxiClb)",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M63 17L35 47 1 47 1 17z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSap);
export default __webpack_public_path__ + "static/media/sap.4a17a49c5784b9ead49da0336141d5c1.svg";
export { ForwardRef as ReactComponent };